<template>
	<div class="mt-4">
		<b-modal ref="loaderModal"
			hide-footer
			title="Loading...">
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="valid_button">
			<button type="submit"
				class="btn btn-valid"
				@click.prevent="sendDatas"
				:disabled = disabled
			>{{ $t("Button.validate") }}
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../../event/event-bus";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ValidStepLogo",
	components: {
		throbber,
		lottie_error,
	},
	props: {
		value: {
			type: String,
			required: true,
		},
		secondaryValue: {
			type: String,
			required: true,
		},
		id: {
			type: Number,
			required: true,
		},
		relativePath: "",
		disabled: Boolean,
		music_enabled: Boolean,
		music_volume: Number,
	},
	data() {
		return {
			text_error: "",
			check: false,
		};
	},
	methods: {
		sendDatas() {
			let $this = this;
			$this.$refs.loaderModal.show();

			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");

			if (this.value !== undefined) {
				bodyFormData.append("title", this.value);
			}

			if (this.secondaryValue !== undefined) {
				bodyFormData.append("secondaryTitle", this.secondaryValue);
			}

			if (this.secondaryValue == null && this.title == null) {
				bodyFormData.append("isCompleted", "0");
			}
			else {
				bodyFormData.append("isCompleted", "1");
			}

			if (this.music_enabled !== undefined) {
				bodyFormData.append("music_enabled", this.music_enabled ? "true" : "false");
			}
			if (this.music_volume !== undefined) {
				bodyFormData.append("music_volume", this.music_volume.toString());
			}

			axios.post(BASE_URL + "/public/api/stepTitles/" + this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();

				if ($this.value.length > 0) {
					EventBus.$emit("setModified", false);
					EventBus.$emit("setModificationLabel", "");
					EventBus.$emit("setModificationSecondaryTitleLabel", "");
					EventBus.$emit("setStepLogoComplete", $this.id);
					EventBus.$emit("unlock_steps", {id: $this.id, type: "App\\StepTitle"});
				}
			})
			.catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
	},
};
</script>

<style scoped>
.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}
</style>
